module.exports = require("./nyn-UG");